import React from 'react';
const Chart = () => null;

export function getChartComponent(chartType, props) {
  return <Chart type={chartType} {...props} />;
}

function cutHex(h) {
  return h.charAt(0) === '#' ? h.substring(1, 7) : h;
}
function hexToR(h) {
  return parseInt(cutHex(h).substring(0, 2), 16);
}
function hexToG(h) {
  return parseInt(cutHex(h).substring(2, 4), 16);
}
function hexToB(h) {
  return parseInt(cutHex(h).substring(4, 6), 16);
}
function hexToRGB(hex, transparency) {
  return `rgba(${hexToR(hex)}, ${hexToG(hex)}, ${hexToB(hex)}, ${transparency})`;
}

export function getDataChart(points, labels, color) {
  const data = [];
  const minLength = Math.min(points.length, labels.length);
  let i = 0;
  for (i; i < minLength; i++) {
    data.push([labels[i], points[i]]);
  }
  return { data, color: hexToRGB(color, 1), fillColor: hexToRGB(color, 0.4) };
}

export function getMaxChart(labels, max, color) {
  const data = [];
  const maxValue = !max || isNaN(max) ? 0 : max;
  let i = 0;
  for (i; i < labels.length; i++) {
    data.push([labels[i], maxValue]);
  }
  const colorValue = maxValue === 0 ? 'rgba(1,1,1,0)' : hexToRGB(color, 1);
  return { data, color: colorValue, fillColor: null };
}
